<ui-popover #popover="ui-popover">
    <ng-template ui-popover-template>
        <span [innerHTML]="sanitizedText"> </span>
    </ng-template>
</ui-popover>
